<template>
  <div class="mainNew">
    <div class="topTitle">
      <span style="font-family:'PingFangBold';color:#333333;font-size: 16px;">财务中心</span>
      / 收支明细
    </div>
    <div class="input-student-management">
      <section>
        <el-form :inline="true" :model="formInline" class="demo-form-inline" size="small">
          <el-form-item label="经办日期">
            <el-date-picker style="width: 200px;" value-format="yyyy-MM-dd HH:mm:ss" v-model="formInline.creatTime1" type="datetimerange" align="right" start-placeholder="开始日期" end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']" placement="bottom-start">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="项目">
            <el-select v-model="formInline.bussiness_type" placeholder="请选择" clearable>
              <el-option v-for="item in options2" :key="item.id" :label="item.title" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="支付方式">
            <el-select @change="search" v-model="formInline.pay_type" placeholder="请选择" clearable>
              <el-option v-for="item in options4" :key="item.id" :label="item.title" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="经办人">
            <el-select @change="search" v-model="formInline.deal_user_id" placeholder="请选择" clearable>
              <el-option v-for="item in options3" :key="item.id" :label="item.realname" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="订单号">
            <el-input v-model="formInline.xm_order_code" placeholder="请输入订单号" clearable></el-input>
          </el-form-item>
          <el-form-item label="创建时间">
            <el-date-picker style="width: 200px;" value-format="yyyy-MM-dd HH:mm:ss" v-model="formInline.creatTime" type="datetimerange" align="right" start-placeholder="开始日期" end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']" placement="bottom-start">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="收支类型">
            <el-radio-group v-model="formInline.type" @change="search">
              <el-radio label="">全部</el-radio>
              <el-radio label="1">支付记录</el-radio>
              <el-radio label="2">退款记录</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="search" v-if="$attrs.methodAuthTabView('查询')">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" plain @click="handleExport" v-if="$attrs.methodAuthTabView('导出')">导出</el-button>
          </el-form-item>
        </el-form>
        <div class="sumBg">
          <span style="font-weight: bold;">合计收入(元): </span>
          <span style="font-weight: bold;margin-left:10px;color:#ee7d37;">{{
            inSum
          }}</span>
          <span style="margin-left: 10px;font-weight: bold;">
            合计支出(元):</span>
          <span style="font-weight: bold;margin-left:10px;color:#ee7d37;">{{
            outSum
          }}</span>
        </div>
        <div>
          <el-table ref="multipleTable" :data="tableData" style="width: 100%; margin-top: 20px;" :header-cell-style="{
              background: '#f5f7fa',
              color: '#606266',
              'font-size': '14px',
            }" stripe>
            <el-table-column prop="deal_date" label="经办日期" show-overflow-tooltip width="180"></el-table-column>
            <el-table-column prop="" label="项目">
              <template slot-scope="scope">
                <span v-if="scope.row.bussiness_type === 1">报名/续费</span>
                <span v-if="scope.row.bussiness_type === 2">转课 </span>
                <span v-if="scope.row.bussiness_type === 3">退课 </span>
                <span v-if="scope.row.bussiness_type === 4">退物品 </span>
                <span v-if="scope.row.bussiness_type === 5">退费用 </span>
                <span v-if="scope.row.bussiness_type === 6">账户充值 </span>
                <span v-if="scope.row.bussiness_type === 7">账户退款 </span>
                <span v-if="scope.row.bussiness_type === 8">补交 </span>
              </template>
            </el-table-column>
            <el-table-column prop="" label="收支类型">
              <template slot-scope="scope">
                <span v-if="scope.row.type === 1">收入</span>
                <span v-if="scope.row.type === 2">支出 </span>
              </template>
            </el-table-column>
            <el-table-column prop="final_amount" label="收支金额(元)">
              <template slot-scope="scope">
                <span>￥{{ scope.row.final_amount.toFixed(2) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="" label="支付方式">
              <template slot-scope="scope">
                <span v-if="scope.row.pay_type === 1">支付宝 </span>
                <span v-if="scope.row.pay_type === 2">微信 </span>
                <span v-if="scope.row.pay_type === 3">现金 </span>
                <span v-if="scope.row.pay_type === 4">网银转账 </span>
                <span v-if="scope.row.pay_type === 5">Pos机刷卡 </span>
                <span v-if="scope.row.pay_type === 6">账户 </span>
              </template>
            </el-table-column>
            <el-table-column prop="deal_user_realname" label="经办人"></el-table-column>
            <el-table-column prop="xmOrderCode" label="关联订单号" width="200px"></el-table-column>
            <el-table-column prop="stu_name" label="收付款人"></el-table-column>
            <el-table-column prop="created_time" label="创建时间" show-overflow-tooltip width="180"></el-table-column>

            <!--
                        <el-table-column prop="" label="凭证">
                            <template slot-scope="scope">
                                <span @click="lookVoucher(scope.row)" style="color:#2AC250">查看</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="" label="支付流水号"></el-table-column>
-->
          </el-table>
        </div>
        <div class="pagination-style">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page_no" :page-sizes="[10, 15, 20, 30, 40, 50, 100]" :page-size="page_size" layout="total,sizes, prev, pager, next, jumper" :total="total"></el-pagination>
        </div>
      </section>
    </div>
    <el-dialog title="上传凭证" :visible.sync="dialogVisible3" width="30%">
      <div style="margin-top:15px">
        <el-upload action="" :http-request="uploadFileSchool" :on-remove="handleRemove1" :on-change="handleChangeFile1" :auto-upload="false" :limit="3" :file-list="imgList1" list-type="picture">
          <el-button size="mini" type="primary" plain>点击上传<i class="el-icon-upload el-icon--right"></i>
          </el-button>
          <div slot="tip" class="el-upload__tip">
            只能上传jpg/png文件，且不超过500kb
          </div>
        </el-upload>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible3 = false">取 消</el-button>
        <el-button type="primary" @click="submitVoucher">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  // getXmOrderPayRecordList,
  getCampusUserList,
  uploadXmOrderPayProofImg,
} from '@/api/educational.js'
import {
  api_orderPayRecordSelectOrderPayDetail
} from '@/api/javaApi'

import uploadFileSchool from '@/config/uploadFileSchool'
import moment from 'moment'

import { downLoadFileExcelHandle } from '@/utils/exportExcel'

export default {
  name: 'input-student-management',
  data() {
    return {
      inSum: 0,
      outSum: 0,

      payId: '',
      imgList1: [],
      dialogVisible3: false,

      xmLesonHourRecordInfo: {},
      student_user_id: '',
      tableData: [],
      tableData1: [],
      page_no: 1,
      page_size: 10,
      total: 1,
      formInline: {
        type: '',
        cost_type_arr: [],
        creatTime: [],
        creatTime1: [],
        bussiness_type: []
      },
      options3: [],
      options2: [
        {
          id: 1,
          title: '报名/续费',
        },
        {
          id: 2,
          title: '转课',
        },
        {
          id: 3,
          title: '退课',
        },

        {
          id: 4,
          title: '退物品',
        },
        {
          id: 5,
          title: '退费用',
        },
        {
          id: 6,
          title: '账户充值',
        },
        {
          id: 7,
          title: '账户退款',
        },
        {
          id: 8,
          title: '补交',
        },
      ],
      options5: [], //班级
      options4: [
        {
          id: '1',
          title: '支付宝',
        },
        {
          id: '2',
          title: '微信',
        },
        {
          id: '3',
          title: '现金',
        },
        {
          id: '4',
          title: '网银转账',
        },
        {
          id: '5',
          title: 'Pos机刷卡',
        },
        {
          id: '6',
          title: '账户',
        },
      ],
    }
  },
  mounted() {
    const startDate = moment()
      .month(moment().month())
      .startOf('month')
      .format('YYYY-MM-DD 00:00:00')
    const endDate = moment()
      .month(moment().month())
      .endOf('month')
      .format('YYYY-MM-DD 23:59:59')
    this.formInline.creatTime1.push(startDate, endDate)
    console.log(startDate, 789465)
    console.log(endDate, 789465)

    this.getCampusUserList()
    this.getXmOrderPayRecordList()
    // this.getXmGoodsListForgetXmLessonHourRecor()
  },
  methods: {
    submitVoucher() {
      uploadXmOrderPayProofImg({
        xm_order_pay_record_id: this.payId,
        proof_img: JSON.stringify(this.imgList1),
      }).then(() => {
        this.getXmOrderPayRecordList()
        this.dialogVisible3 = true
      })
    },
    uploadFileSchool() { },
    handleRemove1(file) {
      console.log(file, 1621323)
      this.imgList1.splice(this.imgList1.indexOf(file), 1)
    },
    async handleChangeFile1(file, fileList) {
      if (!this.uploadFileTime) {
        await this.uploadFileOss1(fileList)
      }
    },
    async uploadFileOss1(list) {
      this.uploadFileTime = true
      await uploadFileSchool(list, this.$store.state.user.userInfo.code).then(
        (res) => {
          console.log('上传图片')
          console.log(res)
          this.imgList2 = res
          this.imgList1 = []
          this.imgList2.map((item) => {
            this.imgList1.push({
              url: item.url,
            })
          })
          // console.log(this.xmOrderInfo.xmOrderPayRecordArr[0].proof_img, 4654623);

          this.uploadFileTime = false
        }
      )
    },
    lookVoucher(row) {
      this.imgList1 = JSON.parse(row.proof_img)
      console.log(row, 787874)
      this.payId = row.id
      this.dialogVisible3 = true
    },

    search() {
      this.page_no = 1
      this.getXmOrderPayRecordList()
    },
    //获得校区员工列表
    getCampusUserList() {
      getCampusUserList({
        campusId: this.$store.state.user.selected_schools[0],
      }).then((res) => {
        console.log('获得学校用户列表')
        console.log(res)
        this.options3 = res.campusUserList
      })
    },
    getXmOrderPayRecordList() {
      api_orderPayRecordSelectOrderPayDetail({
        eduCampusId: this.$store.state.user.selected_schools[0],
        type: this.formInline.type,
        businessType: this.formInline.bussiness_type || null,
        payType: this.formInline.pay_type,
        userId: this.formInline.deal_user_id,
        orderCode: this.formInline.xm_order_code,
        startDealDate:
          this.formInline.creatTime1 === null
            ? ''
            : this.formInline.creatTime1[0],
        endDealDate:
          this.formInline.creatTime1 === null
            ? ''
            : this.formInline.creatTime1[1],

        startCreateDate:
          this.formInline.creatTime === null
            ? ''
            : this.formInline.creatTime[0],
        endCreateDate:
          this.formInline.creatTime === null
            ? ''
            : this.formInline.creatTime[1],
        pageRequest: {
          pageNum: this.page_no,
          pageSize: this.page_size,
        }
      }).then((res) => {
        this.inSum = res.totalContent.totalIncome
        this.outSum = res.totalContent.totalExpenses

        this.tableData = res.content
        this.tableData.forEach(item => {
          item.bussiness_type = item.businessType
          item.created_time = item.createdTime
          item.deal_date = item.dealDate
          // item.deal_user_id = item.79
          item.deal_user_realname = item.dealUserName
          // item.educational_institution_campus_id = item.43
          // item.educational_institution_id = item.36
          item.final_amount = item.finalAmount
          // item.give_amount = item.0
          // item.id = item.21584
          // item.is_vaild = item.true
          item.pay_type = item.payType
          // item.proof_img = item."[]"
          // item.stu_headImgUrl = item."https://wugecdn.steam.fun/resources/static/homepage/nvxueshengtouxiang-min.png"
          item.stu_name = item.stuName
          // item.stu_sex = item."女"
          // item.stu_userCode = item."80e3dc40-4331-4262-86d6-e49b7f452f36"
          // item.stu_username = item."caoxiaoxiao01"
          // item.student_user_id = item.160334
          // item.type = item.type
          item.xmOrderCode = item.code
          // item.xm_account_id = item.null
          // item.xm_order_id = item.30242
        })
        this.total = res.totalSize
      })
    },
    handleExport() {
      const params = {
        eduCampusId: this.$store.state.user.selected_schools[0],
        type: this.formInline.type,
        businessType: this.formInline.bussiness_type || null,
        payType: this.formInline.pay_type,
        userId: this.formInline.deal_user_id,
        orderCode: this.formInline.xm_order_code,
        startDealDate:
          this.formInline.creatTime1 === null
            ? ''
            : this.formInline.creatTime1[0],
        endDealDate:
          this.formInline.creatTime1 === null
            ? ''
            : this.formInline.creatTime1[1],

        startCreateDate:
          this.formInline.creatTime === null
            ? ''
            : this.formInline.creatTime[0],
        endCreateDate:
          this.formInline.creatTime === null
            ? ''
            : this.formInline.creatTime[1],
      }
      downLoadFileExcelHandle('/java-api/school/orderPayRecord/exportOrderPayDetail', params, '收支明细')

    },
    handleCurrentChange(val) {
      this.page_no = val
      this.getXmOrderPayRecordList()
    },
    handleSizeChange(val) {
      this.page_size = val
      this.getXmOrderPayRecordList()
    },
  },
}
</script>

<style lang="scss" scoped>
.sumBg {
  width: 100%;
  background-color: #fcf1e8;
  padding: 10px 10px;
  margin-top: 10px;
  border-radius: 5px;
}

.mainNew {
  height: 100%;
}

.topTitle {
  height: 60px;
  background: #fff;
  margin: 10px;
  padding: 20px;
  border-radius: 5px;
  box-sizing: border-box;
  font-size: 14px;

  span {
    color: rgba(0, 0, 0, 0.45);
  }
}

.input-student-management {
  min-height: calc(100% - 30px);

  background-color: #fff;
  margin: 10px;
  border-radius: 5px;

  section {
    padding-top: 20px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 20px;

    .table-style {
      margin-top: 20px;
    }
  }

  .el-dropdown-link {
    cursor: pointer;
    color: #409eff;
    font-size: 12px;
    padding-right: 5px;
  }

  .el-icon-arrow-down {
    font-size: 12px;
  }

  .flowrecord {
    height: calc(100vh - 280px);
    margin: 20px;
    overflow-y: scroll;
  }
}
</style>

<style>
.input-student-management .el-divider--horizontal {
  margin-bottom: 20px;
  margin-top: 5px;
}

.liStyle {
  width: 50%;
  float: left;
  margin-bottom: 15px;
}
</style>
